














import { Vue, Watch, Component } from 'vue-property-decorator'
import Banner from '@/components/Banner.vue'
import TabList from '@/components/TabList.vue'

@Component({
  components: {
    Banner,
    TabList
  }
})
export default class LearningCommonweal extends Vue {
  tabList = [
    // { id: 0, name: 'researchProject', text: '课题研究', path: 'research-project' },
    { id: 1, name: 'langProtection', text: '语言保护与推广', path: 'lang-protection' },
    { id: 2, name: 'langCompetition', text: 'Language Champion', path: 'lang-competition' }
  ]
  navigation = [
    {
      text: '首页',
      path: '/'
    },
    {
      text: '学术与公益',
      path: '/learning-commonweal'
    }
    // {
    //   text: '课题研究',
    //   path: ''
    // }
  ]
  created () {
    this.changeRoute()
  }
  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }
  changeRoute () {
    this.navigation.forEach((item:any, index:number) => {
      console.log('item', item)
      if (item.path === '') {
        item.text = this.$route.query.type ? this.$route.query.type : '课题研究'
      }
    })
  }
}
